module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', [_c('navbar'), _vm._v(" "), _c('div', {
    ref: "mybox",
    staticClass: "detail_slide_m1"
  }, [_c('div', {
    staticClass: "zengo max_width"
  }, [_c('h1', {
    staticClass: "banner-title"
  }, [_vm._v("ZENGÕ M1")]), _vm._v(" "), _c('p', {
    staticClass: "Store-banner-sm-title"
  }, [_vm._v(_vm._s(_vm.$t('m1_details_page_banner_title')))]), _vm._v(" "), _c('p', {
    staticClass: "banner-content",
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('m1_details_page_banner_sm_title')))]), _vm._v(" "), _c('img', {
    staticClass: "zengo-m1-img",
    staticStyle: {
      "margin-top": "3%"
    },
    attrs: {
      "src": require("../../../assets/store/m1/zengo-m1.png"),
      "width": "200"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "layout-content ",
    staticStyle: {
      "z-index": "1",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "Product-content mogos"
  }, [_c('div', {
    staticClass: "Product-content max_width",
    staticStyle: {
      "background": "#FFFFFF",
      "padding": "6% 0 6% 0"
    }
  }, [_c('Row', {
    staticStyle: {
      "padding": "0 3% 0 3%"
    }
  }, [_c('Col', {
    staticClass: "Product-left",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "md": 13
    }
  }, [_c('img', {
    staticClass: "mogos-logo",
    attrs: {
      "src": require("../../../assets/store/m1/zengom1_2.png")
    }
  })]), _vm._v(" "), _c('Col', {
    staticClass: "Product-right",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": 11
    }
  }, [_c('p', {
    staticClass: "Product-name"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('m1_details_page_product_title')) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "Product-price"
  }, [_vm._v("\n                        $" + _vm._s(_vm.goods_info.goods_price) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "Product-details"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('m1_details_page_product_content')) + "\n                    ")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Product-details-li"
  }, [_vm._v(_vm._s(_vm.$t('m1_details_page_product_content1')))]), _vm._v(" "), _c('li', {
    staticClass: "Product-details-li"
  }, [_vm._v(_vm._s(_vm.$t('m1_details_page_product_content2')))]), _vm._v(" "), _c('li', {
    staticClass: "Product-details-li"
  }, [_vm._v(_vm._s(_vm.$t('m1_details_page_product_content3')))])]), _vm._v(" "), _c('buy', {
    attrs: {
      "id": parseInt(_vm.$route.query.id),
      "maxCount": parseInt(_vm.goods_info.store_count)
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "Product-content"
  }, [_c('Row', [_c('i-col', {
    staticClass: "Product-right",
    staticStyle: {
      "text-align": "center",
      "padding": "5% 0"
    },
    attrs: {
      "span": "24"
    }
  }, [_c('p', {
    staticClass: "idual-title"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('m1_details_page_advantage1')) + "\n                        ")]), _vm._v(" "), _c('p', {
    staticClass: "idual-text"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('m1_details_page_advantage1_content')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "igo-product-details-page",
    staticStyle: {
      "background": "#FFFFFF",
      "margin-top": "2%"
    }
  }, [_c('img', {
    staticClass: "cable-img-1",
    attrs: {
      "src": require("../../../assets/store/m1/zengom1_bg_2.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "idual-i",
    staticStyle: {
      "margin": "40px 0"
    }
  }, [_c('Row', [_c('i-col', {
    staticStyle: {
      "color": "transparent"
    },
    attrs: {
      "xs": 2,
      "sm": 4,
      "md": 6,
      "lg": 8
    }
  }, [_vm._v("c")]), _vm._v(" "), _c('i-col', {
    staticClass: "m1-v",
    attrs: {
      "span": 24
    }
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": require("../../../assets/store/m1/icon2.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('m1_details_page_features1')))])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../../assets/store/m1/icon3.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('m1_details_page_features2')))])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../../assets/store/m1/icon4.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('m1_details_page_features3')))])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../../assets/store/m1/icon5.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('m1_details_page_features4')))])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../../assets/store/m1/icon6.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('m1_details_page_features5')))])])])]), _vm._v(" "), _c('i-col', {
    staticStyle: {
      "color": "transparent"
    },
    attrs: {
      "xs": 2,
      "sm": 4,
      "md": 6,
      "lg": 8
    }
  }, [_vm._v("c")])], 1)], 1)]), _vm._v(" "), _c('i-col', {
    staticClass: "Product-right",
    staticStyle: {
      "text-align": "center",
      "padding": "5% 0"
    },
    attrs: {
      "span": "24"
    }
  }, [_c('p', {
    staticClass: "idual-title"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('m1_details_page_advantage2')) + "\n                        ")]), _vm._v(" "), _c('p', {
    staticClass: "idual-text"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('m1_details_page_advantage2_content')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "idual-i",
    staticStyle: {
      "margin": "50px 0"
    }
  }, [_c('Row', {
    staticClass: "m1-v3"
  }, [_c('i-col', {
    attrs: {
      "md": 6,
      "sm": 12,
      "xs": 12
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/store/m1/icon7.png"),
      "width": "80%"
    }
  })]), _vm._v(" "), _c('i-col', {
    attrs: {
      "md": 6,
      "sm": 12,
      "xs": 12
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/store/m1/icon8.png"),
      "width": "80%"
    }
  })]), _vm._v(" "), _c('i-col', {
    attrs: {
      "md": 6,
      "sm": 12,
      "xs": 12
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/store/m1/icon9.png"),
      "width": "80%"
    }
  })]), _vm._v(" "), _c('i-col', {
    attrs: {
      "md": 6,
      "sm": 12,
      "xs": 12
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/store/m1/icon10.png"),
      "width": "80%"
    }
  })])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "Product-content"
  }, [_c('div', {
    staticClass: "Product-content",
    staticStyle: {
      "background-image": "linear-gradient(120deg, #FFFFFF 0%, #FDFDFD 30%,#E7E8E9 100%)",
      "padding": "3% 0 0 0"
    }
  }, [_c('p', {
    staticClass: "idual-title"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('m1_details_page_advantage3')) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "idual-text"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('m1_details_page_advantage3_content')) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "Product-content-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/store/m1/zengom1_4.png"),
      "width": "100%"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "Product-content max_width"
  }, [_c('div', {
    staticClass: "Product-content",
    staticStyle: {
      "padding": "3% 0 0 0"
    }
  }, [_c('p', {
    staticClass: "idual-title"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('m1_details_page_advantage4')) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "idual-text"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('m1_details_page_advantage4_content')) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "Product-content-img-1"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/store/m1/zengom1_5.png"),
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Product-content max_width",
    staticStyle: {
      "padding": "3% 0 0 0"
    }
  }, [_c('p', {
    staticClass: "idual-title"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('m1_details_page_advantage5')) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "idual-text"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('m1_details_page_advantage5_content')) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "Product-content-img-2"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/store/m1/zengom1_bg_3.png"),
      "width": "100%"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "Product-content"
  }, [_c('div', {
    staticClass: "Product-content",
    staticStyle: {
      "background-image": "linear-gradient(120deg, #FFFFFF 0%, #FDFDFD 30%,#E7E8E9 100%)",
      "padding": "10% 0 10% 0"
    }
  }, [_c('Row', {
    staticStyle: {
      "max-width": "820px",
      "margin": "0 auto"
    }
  }, [_c('Col', {
    staticClass: "Product-right",
    attrs: {
      "md": 12
    }
  }, [_c('div', {
    staticClass: "Product-right-main"
  }, [_c('ul', {
    staticClass: "Parameter"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('details_page_product_parameters')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('m1_details_page_product_parameters1')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('m1_details_page_product_parameters2')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('m1_details_page_product_parameters3')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('m1_details_page_product_parameters4')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('m1_details_page_product_parameters5')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('m1_details_page_product_parameters6')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('m1_details_page_product_parameters7')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('m1_details_page_product_parameters8')))])])])]), _vm._v(" "), _c('Col', {
    staticClass: "Product-left",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "md": 12
    }
  }, [_c('img', {
    staticClass: "m1-img",
    attrs: {
      "src": require("../../../assets/store/m1/zengom1_3.png"),
      "width": "100%"
    }
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "detail-basis max_width",
    staticStyle: {
      "max-width": "1200px",
      "margin": "0 auto"
    }
  }, [_c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('shopping_notes')))]), _vm._v(" "), _c('li', [_vm._v("\n                        " + _vm._s(_vm.$t('shopping_notes_tip')) + "\n                    ")])]), _vm._v(" "), _c('guess')], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1d17fba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDetails/iGO/M1.vue
// module id = 862
// module chunks = 0